import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PositionTooltipType } from './awesome-tooltip-v2.directive';

@Component({
  selector: 'app-awesome-tooltip-v2',
  templateUrl: './awesome-tooltip-v2.component.html',
  styleUrls: ['./awesome-tooltip-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AwesomeTooltipV2Component {
  @Input() patientSignerSaved = null;
  @Input() tooltipText = '';
  @Input() positionTooltip: PositionTooltipType = 'topCenter';
  @Input() textAlign: 'center' | 'left' = 'center';
  @Input() actions: boolean = false;
  @Input() insideTable: boolean = false;
}
